// extracted by mini-css-extract-plugin
export default {"setting--inverted":"NCqUit2","dark-theme":"Qnx1YqD","tabs":"yIy4oqV","tablist":"jkEW1nd","button":"DmSS_6H","image":"E5eDyoO","active":"QRfxHOe","panel":"_kMn5Yg"};